/**
 * Ship tay logistics tích hợp — theo RFC shopee manual shipment (pickup/dropoff).
 */
import Swal from 'sweetalert2';

export const MANUAL_SHIP_NONE = 'auto';
export const MANUAL_SHIP_PICKUP = 'pickup';
export const MANUAL_SHIP_DROPOFF = 'dropoff';
/** preset từ API shipping-parameter → pickup/dropoff object sẵn */
export const SHIP_UI_MODE_PRESET = 'preset';

/**
 * @param {object} parsed - kết quả từ showManualShipmentSwalHtml (preConfirm)
 * @returns {object}
 */
export function buildCreateShipmentExtras(parsed) {
  if (!parsed || parsed.mode === MANUAL_SHIP_NONE) {
    return {};
  }
  if (parsed.mode === SHIP_UI_MODE_PRESET) {
    if (parsed.shipType === 'pickup' && parsed.pickup) {
      return { shipType: 'pickup', pickup: parsed.pickup };
    }
    if (parsed.shipType === 'dropoff' && parsed.dropoff) {
      return { shipType: 'dropoff', dropoff: parsed.dropoff };
    }
    return {};
  }
  if (parsed.mode === MANUAL_SHIP_PICKUP && parsed.pickup) {
    return { shipType: 'pickup', pickup: parsed.pickup };
  }
  if (parsed.mode === MANUAL_SHIP_DROPOFF && parsed.dropoff) {
    return { shipType: 'dropoff', dropoff: parsed.dropoff };
  }
  return {};
}

/** Swal markup + didOpen bindings cho form ship tay — chỉ attach một lần mỗi DOM */
export function attachManualShipmentSwalListeners() {
  const sel = document.getElementById('swal-manual-ship-type');
  const wrap = document.getElementById('swal-manual-ship-json-wrap');
  const ta = document.getElementById('swal-manual-ship-json');
  const hint = document.getElementById('swal-manual-ship-hint');
  if (!sel || !wrap || !ta) return;
  if (sel.dataset.swManualBound === '1') return;
  sel.dataset.swManualBound = '1';

  const syncUi = () => {
    const v = sel.value;
    const show = v !== MANUAL_SHIP_NONE;
    wrap.style.display = show ? 'block' : 'none';
    ta.value = '';
    if (hint) {
      hint.textContent =
        v === MANUAL_SHIP_PICKUP
          ? 'Dán nguyên khối thông tin lấy hàng mà Shopee/Seller Centre hiển thị (đủ địa chỉ, khung giờ, kênh VC…).'
          : v === MANUAL_SHIP_DROPOFF
            ? 'Dán nguyên khối thông tin gửi hàng tại điểm (bưu cục/kênh VC) theo màn hình Shopee.'
            : '';
    }
    if (v === MANUAL_SHIP_PICKUP) {
      ta.placeholder =
        'Dán vào đây toàn bộ nội dung đã copy từ Seller Shopee hoặc được bộ phận kỹ thuật gửi…';
    } else if (v === MANUAL_SHIP_DROPOFF) {
      ta.placeholder =
        'Dán vào đây toàn bộ nội dung đã copy từ Seller Shopee hoặc được bộ phận kỹ thuật gửi…';
    }
  };
  sel.addEventListener('change', syncUi);
  syncUi();
}

/**
 * SweetAlert preConfirm parser — trả object cho buildCreateShipmentExtras
 */
export function parseManualShipmentPreConfirm() {
  const sel = document.getElementById('swal-manual-ship-type');
  const ta = document.getElementById('swal-manual-ship-json');
  if (!sel) return { mode: MANUAL_SHIP_NONE };
  const type = sel.value;
  if (type === MANUAL_SHIP_NONE) {
    return { mode: MANUAL_SHIP_NONE };
  }
  const raw = ta ? ta.value.trim() : '';
  if (!raw) {
    Swal.showValidationMessage(
      'Bạn đã chọn Pickup/Dropoff nhưng chưa điền ô bên dưới. Hãy dán khối thông tin Shopee cung cấp (trên Seller Centre) hoặc liên hệ IT/support.',
    );
    return false;
  }
  let obj;
  try {
    obj = JSON.parse(raw);
  } catch (e) {
    Swal.showValidationMessage(
      'Nội dung dán vào chưa đúng. Thử copy lại một lần đủ khối (kiểm tra dấu phẩy, dấu ngoặc…), hoặc nhờ người có màn Shopee gửi đúng đoạn.',
    );
    return false;
  }
  if (obj === null || typeof obj !== 'object' || Array.isArray(obj)) {
    Swal.showValidationMessage(
      'Cần một khối thông tin đầy đủ (pickup hoặc dropoff), không phải chỉ một dòng rỗng hoặc danh sách không đúng định dạng.',
    );
    return false;
  }
  if (type === MANUAL_SHIP_PICKUP) {
    return { mode: MANUAL_SHIP_PICKUP, pickup: obj };
  }
  if (type === MANUAL_SHIP_DROPOFF) {
    return { mode: MANUAL_SHIP_DROPOFF, dropoff: obj };
  }
  return { mode: MANUAL_SHIP_NONE };
}

export function getManualShipmentSwalHtml() {
  return `
    <div class="swal-manual-form card card-body bg-light px-3 py-3 mb-0">
      <p class="small text-muted mb-3 mb-lg-4 swal-manual-form__hint">
        Thường để <strong>Tự động</strong>. Chỉ đổi khi tạo vận đơn báo lỗi không lấy được thông tin pickup/dropoff —
        khi đó chọn <strong>Pickup</strong> hoặc <strong>Dropoff</strong> và <strong>dán</strong> vào ô bên dưới
        đúng khối thông tin trên <strong>Seller Centre</strong> hoặc nhờ IT hỗ trợ copy.
        Kỹ thuật phía máy chủ vẫn đối chiếu đúng định dạng API Shopee; bạn chỉ cần dán đúng đoạn được cung cấp.
      </p>
      <div class="form-group mb-2 mb-lg-3">
        <label for="swal-manual-ship-type" class="font-weight-bolder font-size-sm text-dark mb-2 d-block">
          Phương thức lấy/ghi thông tin vận chuyển
        </label>
        <select id="swal-manual-ship-type" class="form-control form-control-sm">
          <option value="${MANUAL_SHIP_NONE}">Tự động (khuyến nghị)</option>
          <option value="${MANUAL_SHIP_PICKUP}">Pickup — dán thông tin lấy hàng (khi được hướng dẫn)</option>
          <option value="${MANUAL_SHIP_DROPOFF}">Dropoff — dán thông tin gửi tại điểm (khi được hướng dẫn)</option>
        </select>
      </div>
      <div id="swal-manual-ship-json-wrap" class="mt-2" style="display: none;">
        <label for="swal-manual-ship-json" class="font-weight-bold font-size-sm text-dark d-block mb-1">
          Nội dung Shopee/Seller (dán nguyên khối vào đây)
        </label>
        <p id="swal-manual-ship-hint" class="small text-muted mb-2"></p>
        <textarea id="swal-manual-ship-json"
          class="form-control form-control-sm text-monospace"
          rows="5"
          placeholder=""
          spellcheck="false"
        ></textarea>
      </div>
    </div>
  `;
}
